const StreamResponse = async (body, handleStreamObjects) => {
  const chunks = [];
  const reader = body.pipeThrough(new TextDecoderStream()).getReader();

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;

    chunks.push(value);
  }

  return JSON.parse(chunks);
};

export default StreamResponse;
